import { css } from '@emotion/css';
import {
  ColorsNeutral150,
  ColorsNeutral400,
  ColorsWhite,
  Spacings1,
  ShadowsBox,
  Dimensions2,
  Dimensions4,
  ColorsPrimary100,
} from '@efexteam/design-tokens';

const tableContainer = css({
  '&.MuiTableContainer-root': {
    overflowX: 'auto',
    borderCollapse: 'collapse',
    width: '100%',

    '&::-webkit-scrollbar': {
      height: Dimensions2,
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: ColorsNeutral150,
      borderRadius: Dimensions2,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: ColorsNeutral400,
      borderRadius: Dimensions2,
    },

    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: ColorsNeutral400,
    },
  },
});

const table = css({
  '& .MuiTableCell-root': {
    border: 'none',
    padding: `${Dimensions2} ${Dimensions4}`,
    minWidth: '150px',
    maxWidth: '350px',

    '&:first-of-type': {
      minWidth: '250px',
    },
  },
  '& .MuiTableBody-root .MuiTableRow-root:hover': {
    backgroundColor: ColorsNeutral150,
  },
});

const tableHead = css({
  '&.MuiTableHead-root': {
    backgroundColor: 'transparent',
  },
});

const tableHeaderCell = (sticky?: boolean) =>
  css({
    '&.MuiTableCell-root': {
      textTransform: 'lowercase',
      fontWeight: 500,
      paddingTop: Spacings1,
      paddingBottom: Spacings1,
      backgroundColor: ColorsPrimary100,

      '&:first-letter': {
        textTransform: 'uppercase',
      },

      '& .MuiTypography-root': {
        color: ColorsNeutral400,
      },
    },
    ...(sticky && {
      '&.MuiTableCell-root': {
        position: 'sticky',
        left: 0,
        paddingLeft: Spacings1,
        zIndex: 1,
        backgroundColor: ColorsPrimary100,
        boxShadow: `${ShadowsBox.offsetX} ${ShadowsBox.offsetY} ${ShadowsBox.blur} ${ShadowsBox.spread} rgba(0, 0, 0, ${ShadowsBox.colorOpacity})`,

        '& .MuiTypography-root': {
          color: ColorsNeutral400,
        },
      },
    }),
  });

const tableCell = (sticky?: boolean) =>
  css({
    '&.MuiTableCell-root': {
      ...(sticky && {
        position: 'sticky',
        left: 0,
        paddingLeft: Spacings1,
        backgroundColor: ColorsWhite,
        zIndex: 1,
        boxShadow: `${ShadowsBox.offsetX} ${ShadowsBox.offsetY} ${ShadowsBox.blur} ${ShadowsBox.spread} rgba(0, 0, 0, ${ShadowsBox.colorOpacity})`,
      }),
    },
  });

const clientNameCell = css({
  '& .client-name-section': {
    display: 'flex',
    alignItems: 'center',
    gap: Dimensions2,

    '& .client-name-text': {
      margin: 0,
      marginLeft: Spacings1,
      fontSize: '0.875rem',
      display: 'inline',
      wordBreak: 'break-word',
      whiteSpace: 'normal',
    },
  },
});

const emailCell = css({
  '&.MuiTableCell-root': {
    minWidth: '180px',
    maxWidth: '350px',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },
});

const actionCell = css({
  '&.MuiTableCell-root': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const actionButton = css({
  '&.MuiButton-root': {
    minWidth: '130px',
  },
});

const menuBox = css({
  marginLeft: Spacings1,
});

const ClientsTableStyles = {
  tableContainer,
  table,
  tableHead,
  tableHeaderCell,
  tableCell,
  clientNameCell,
  emailCell,
  actionCell,
  actionButton,
  menuBox,
};

export default ClientsTableStyles;
